
import { computed, defineComponent, reactive, ref, watch } from "vue";
import {
  AdminTableLayout,
  ReportTable,
  DefaultOptionSelect,
} from "@/components/Common";

import {
  useDynamicDialog,
  usePagination,
  useReportTableShowColumn,
} from "@/hooks";

import { tableColumn } from "./staffManageColum";

import {
  GetTokenByLogin,
  GenerateCode,
  CheckQqCodeAndLinkOverDue,
  GianStaffs,
  RemoveMerchantUser,
  DisableUserDataPermission,
} from "@/api-server/modules/defaultServer";
import { formatThisMonth, momentFormat } from "@/utils/formatter";
import { ElMessage, ElMessageBox } from "element-plus";
import store from "@/store/index";
import { actionTypes, mutationTypes } from "@/store/types";

import { useStore } from "vuex";
import { RootState } from "@/@types/store";
import { useBind } from "../hooks";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "StaffManage",
  components: {
    AdminTableLayout,
    ReportTable,
    DefaultOptionSelect,
  },

  setup() {
    const { showTableColumn } = useReportTableShowColumn(tableColumn);
    const { getModelUUID, openModel } = useDynamicDialog();
    const router = useRouter()
    const dialogVisible = ref(false);
    const formData = reactive({
      staffName: "",
      staffPhone: "",
      accountStatus: "",
    });
    const addUserInfo = ref({
      link: "",
      qrCode: "",
      randomCode: "",
    });
    const dueFlag = ref("true");

    const selectData = ref<BUSINESS_SERVE_PLATFORM_PC.GianStaffsResponseDataDataItem[]>([])

    let timer = null as any | null;
    const store = useStore<RootState>();
    const roleId = computed(() => store.getters["user/roleId"]);
    const roleType = computed(() => store.getters["user/roleType"]);
    const roleTypeList = computed(() => {
      return store.state.user.userInfo.menuRoleInfoCO.roleCOList.map((item) => {
        return item.roleType;
      });
    });

    const {
      loading,
      pageNum,
      pageSize,
      pageSizeList,
      totalNum,
      tableData,
      currentPageChangeHandle,
      sizeChangeHandle,
      onSearchHandle,
      requestTableData,
    } = usePagination(GianStaffs.fetch, formData, (editFormData) => {
      return {
        staffName: editFormData.staffName,
        staffPhone: editFormData.staffPhone,
        accountStatus: editFormData.accountStatus,
        roleType: roleType.value + "",
      };
    });

    const { handleBind } = useBind('需要绑定电子面单账号后方可新增员工！')

    const handleSelect = (data: BUSINESS_SERVE_PLATFORM_PC.GianStaffsResponseDataDataItem[]) => {
      selectData.value = data
    }

    function handleAddStaff() {
      handleBind(() => {
        dialogVisible.value = true;
        handleRefreshToken();
      })
    }

    async function handleRefreshToken() {
      const {
        data: { data },
      } = await GetTokenByLogin.fetch(
        {
          refresh_token: store.state.user.refreshToken,
        },
        {
          cacheRequestFn: "return",
        }
      );
      if (data && data.access_token && data.refresh_token) {
        store.commit(`user/${mutationTypes.SET_USER_TOKEN}`, {
          token: data.access_token,
          refreshToken: data.refresh_token,
        });
        await fetchCode();
        await checkDue();
        timer = await setInterval(checkDue, 5000);
      } else {
        store.dispatch(`user/${actionTypes.USER_LOGOUT}`).then(() => {
          router.replace("/");
        });
      }
    }

    async function fetchCode() {
      const {
        data: { data },
      } = await GenerateCode.fetch({
        refreshToke: store.state.user.token,
      });
      addUserInfo.value.qrCode = "data:image/png;base64," + data?.qrCode;
      addUserInfo.value.link = data?.link || "";
      addUserInfo.value.randomCode = data?.randomCode || "";
    }
    async function checkDue() {
      const {
        data: { data },
      } = await CheckQqCodeAndLinkOverDue.fetch({
        randomCode: addUserInfo.value.randomCode,
      });
      dueFlag.value = data || "true";
    }

    async function handleBatchEdit() {
      if (selectData.value.length <=0) {
        return ElMessage.warning({ showClose: true, message: "请选择要进行编辑的员工"})
      }
      const uuid = await getModelUUID(
        "admin/base-setting/permission-config/staff-manage/staffEditDialog"
      );
      openModel(
        uuid,
        {
          type: 'batch',
          formData: {
            slaveRelationUserList: selectData.value.map(v => {
              return {
                slavePhone: v.staffPhone,
                userName: v.staffName,
              }
            })
          },
        },
        {
          updateSuccess: requestTableData,
        }
      );
    }

    async function handleEdit(row: any) {
      const uuid = await getModelUUID(
        "admin/base-setting/permission-config/staff-manage/staffEditDialog"
      );
      openModel(
        uuid,
        {
          formData: { ...row },
        },
        {
          updateSuccess: requestTableData,
        }
      );
    }
    function handleEnable(row: any) {
      let msgContent = row.isEnabled == "1" ? "禁用" : "启用";
      ElMessageBox.confirm("请确认是否要" + msgContent + "该角色？", "警告", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await DisableUserDataPermission.fetch({
            slavePhone: row.staffPhone,
            action: row.isEnabled == "1" ? "0" : "1",
            partnerIdList: row.partnerList ? [row.partnerList] : [],
            roleType: row.roleType ? [row.roleType] : [],
          });
          ElMessage.success(row.isEnabled == "1" ? "禁用成功" : "启用成功");
          onSearchHandle();
        })
        .catch(() => {
          // actionLoading.value = false
        });
    }
    function handleDelete(row: any) {
      ElMessageBox.confirm("请确认是否要删除该角色？", "警告", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await RemoveMerchantUser.fetch({ slavePhone: row.staffPhone });
          ElMessage.success({ showClose: true, message: "删除成功" });
          onSearchHandle();
        })
        .catch(() => {
          // actionLoading.value = false
        });
    }

    function handleDownPic() {
      var alink = document.createElement("a");
      alink.href = addUserInfo.value.qrCode;
      alink.download = "邀请员工二维码"; //图片名
      alink.click();
    }
    function handleCopyLink() {
      var input = document.createElement("input"); // js创建一个input输入框
      input.value = addUserInfo.value.link; // 将需要复制的文本赋值到创建的input输入框中
      document.body.appendChild(input); // 将输入框暂时创建到实例里面
      input.select(); // 选中输入框中的内容
      document.execCommand("Copy"); // 执行复制操作
      document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作
      ElMessage.success({ showClose: true, message: "复制成功" });
    }

    watch(
      () => dialogVisible.value,
      (n) => {
        if (!n) {
          timer && clearInterval(timer);
          timer = null;
        }
      }
    );

    return {
      loading,
      formData,
      onSearchHandle,
      requestTableData,
      showTableColumn,
      tableData,
      formatThisMonth,
      momentFormat,
      handleEdit,
      handleDelete,
      pageNum,
      pageSize,
      pageSizeList,
      totalNum,
      currentPageChangeHandle,
      sizeChangeHandle,
      handleAddStaff,
      dialogVisible,
      fetchCode,
      addUserInfo,
      handleDownPic,
      handleCopyLink,
      handleRefreshToken,
      checkDue,
      dueFlag,
      handleEnable,
      roleId,
      roleType,
      store,
      roleTypeList,
      handleSelect,
      handleBatchEdit,
    };
  },
});
